module.exports = __webpack_public_path__ + "static/img/50.64a376c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s33/pop/50.png
// module id = rFdC
// module chunks = 2